import { Component, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { VacationSwitchComponent } from '../vacation-switch/vacation-switch.component';

export interface Exercise {
  id: number;
  title: string;
  dates: string;
  year: number;
  active?: boolean;
  bottomCardData: { title: string; value: number }[];
}

@Component({
  selector: 'app-exercise-card',
  imports: [MatIconModule, MatDividerModule, VacationSwitchComponent],
  templateUrl: './exercise-card.component.html',
  styleUrl: './exercise-card.component.css',
})
export class ExerciseCardComponent {
  exercise = input.required<Exercise>();
  statusChanged = output<void>();

  constructor(private router: Router) {}

  goToExercise() {
    const id = this.exercise().id;
    const year = this.exercise().year;
    console.log(id, year);
    // pass the whole exercise object in navigation state
    this.router.navigate(
      ['/home', 'vacations', 'drivers', 'exercise', id, year],
      {
        state: { exercise: this.exercise() },
      }
    );
  }

  onStatusChanged() {
    this.statusChanged.emit();
  }
}
